<template>

  <div id="bg">
  <div id="wrapper">

    <!-- Nav and Login Button -->
    <LandingHeader />

    <!-- Title & Subtitle -->
    <center>
    <div class="heading">
      <h1>Get in Touch</h1>
      <h3>Leave your details and we'll reach out</h3>
    </div>
    </center>

    <div id="content">

      <!-- Thank You Message -->
      <div v-if="submitted" class="thank-you">
        <h2>Thanks! We'll be in touch.</h2>
      </div>

      <!-- Contact Form -->
      <form class="email-form" @submit.prevent="checkForm" v-if="!submitted">
        <a-tooltip title="Please enter your name" :visible="show_errors && name === ''">
          <input type="text" placeholder="Full name" v-model="name" @blur="show_errors = false">
        </a-tooltip>
        <a-tooltip title="Please enter a valid email" :visible="show_errors && !isValidEmail(this.email)">
          <input type="email" placeholder="Your work email" v-model="email" @blur="show_errors = false">
        </a-tooltip>
        <button type="submit">Get Started</button>
      </form>

    </div>

  </div>

  <!-- Landing Footer -->
  <LandingFooter />

  </div>


</template>


<script>

import LandingHeader from '@/components/landing/LandingHeader.vue';
import LandingFooter from '@/components/landing/LandingFooter.vue';

export default {

  name: 'signUp',

  components: {
    LandingHeader,
    LandingFooter
  },

  data() {
    return {
      name: '',
      email: '',
      show_errors: false,
      submitted: false
    }
  },

  methods: {

    checkForm(e) {
      this.show_errors = false;
      analytics.track('Sign Up Clicked', { type: 'email' });
      if (!this.name || !this.isValidEmail(this.email)) {
        this.show_errors = true;
      } else {
        this.submitted = true;
        analytics.track('Sign Up Submitted', { name: this.name, email: this.email });
      }
    },

    isValidEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },

  },

  created() {
    analytics.page('Sign Up');
  }

};
</script>



<style lang="scss" scoped>


#content{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 0 auto;
  margin-top: 70px;
  width: 350px;
  p{
    font-size: 15px;
    color: white;
    font-weight: 500;
    text-align: center;
  }
}

h1,
h2{
  color: white;
  text-align: center;
}

.heading{
  display: block;
  margin: 0 auto;
  margin-top: 7%;
  h1{
    font-size: 38px;
    font-weight: 600;
    white-space: nowrap;
  }
  h3{
    font-size: 16px;
    color: white;
    font-weight: 600;
  }
}

.thank-you{
  text-align: center;
  margin-top: 40px;
  h2{
    color: white;
    font-size: 24px;
    font-weight: 600;
  }
}


.email-form{
  margin-top: 20px;
  & > *{
    display: block;
  }
  input{
    color: rgb(30,30,30);
    font-size: 14px;
    font-weight: 500;
    width: 100%;
    padding: 12px;
    margin-bottom: 16px;
    background-color: white;
    outline: none;
    border: 1px solid rgba(255,255,255,.4);
    border-radius: 4px;
    transition: all 0.2s ease;
    &:focus{
      border-color: #3BF5BD;
    }
  }
  button{
    color: #003122;
    font-size: 16px;
    font-weight: 700;
    width: 100%;
    padding: 12px;
    margin-top: 25px;
    background-color: #26E2A9;
    border: none;
    border-radius: 8px;
    transition: all 0.2s ease;
    cursor: pointer;
    &:hover{
      background-color: #00FFC1;
    }
  }
}


.spinner{
  display: block;
  margin: 0 auto;
  margin-top: 50px;
  .ant-spin-dot i{
    background-color: #00FFC1 !important;
  }
}

#bg{
  display: block;
  width: 100%;
  min-height: 100%;
  height: auto;
  background-image:
    url("../assets/landing-world-bg.png"),
    url("../assets/landing-whatsapp-bg.png");
  background-position:
    center,
    top left;
  background-repeat:
    no-repeat,
    repeat;
  overflow: hidden;
}


#wrapper{
  display: block;
  width: 1050px;
  height: 100%;
  padding-top: 100px;
  margin: 0 auto;
  position: relative;
  font-family: 'Montserrat', sans-serif;
}



@media only screen
and (min-device-width: 320px)
and (max-device-width: 480px) {

#wrapper{
  width: 88%;
}
#content{
  flex-direction: column;
  width: 100%;
  align-items: center;
  margin-top: 25px;
  padding-bottom: 50px;
}

h1{
  font-size: 30px !important;
  line-height: 45px !important;
}
h2{
  display: none;
}

.heading{
  margin-top: 40px;
  h1{
    display: inline;
    font-size: 24px !important;
  }
  h3{
    font-size: 15px !important;
  }
  .whatsapp-logo{
    display: inline-block;
    height: 36px;
    width: 36px;
    background-size: 36px;
    margin-left: 8px;
    transform: translateY(8px);
  }
}

#google-btn{
  margin-bottom: 30px;
}

#signup{
  margin-bottom: 30px;
}

.email-form{
  margin-bottom: 30px;
  width: 100%;
}

}

</style>
